<template>
  <iframe class="not-found" ref="not-found" src="https://www.partners.engineering.com/notfound"></iframe>
</template>

<script>
export default { name: 'notFound' }
</script>

<style lang="scss" scoped>
.not-found {
  width: 100vw;
  height: 100vh;
}
</style>
